<template>
    <div class="section-margin-bottom position-relative" v-for="activity in activities" :key="activity.id">

      <h2  class="is-1  mb-6">{{ activity.title }}</h2>


    <div class="level-group-info mb-6">

      <div class="is-flex is-align-items-center">
      <q-icon
        class="mr-3"
        :key="xl"
        :size="xl"
        name="leaderboard"
      />
      <p>Recommended Levels: <b>{{ activity.recommended_levels }}</b></p> 
      </div>
      <div class="is-flex is-align-items-center">
          <q-icon
            class="mr-3"
        :key="xl"
        :size="xl"
        name="groups"
      />
      <p>Suitable for Groups: <b>{{ activity.suitable_for_groups }}</b></p>
      </div>
    </div>
    <q-list class="accordian-container">
        <q-expansion-item
        icon="help"
        label="What Is It?"
        default-opened
        header-class="text-primary"
        popup
      >
        <q-card>
          <q-card-section v-html="activity.what_is_it">
          
          </q-card-section>
        </q-card>
      </q-expansion-item>

            <q-expansion-item
        icon="emoji_objects"
        label="Things to Think About"
        default-opened
        header-class="text-primary"
        popup
      >
        <q-card>
          <q-card-section v-html="activity.things_to_think_about">
          
          </q-card-section>
        </q-card>
      </q-expansion-item>


            <q-expansion-item
        default-opened
        icon="straighten"
        label="Assignment Length"
        header-class="text-primary"
        popup
      >
        <q-card>
          <q-card-section v-html="activity.assignment_length">
          
          </q-card-section>
        </q-card>
      </q-expansion-item>

            <q-expansion-item
        default-opened    
        icon="groups"
        label="Group Work"
        header-class="text-primary"
        popup
      >
        <q-card>
          <q-card-section v-html="activity.group_work">
          
          </q-card-section>
        </q-card>
      </q-expansion-item>

            <q-expansion-item
        default-opened
        icon="plagiarism"
        label="Plagiarism Issues"
        popup
        header-class="text-primary"
      >
        <q-card>
          <q-card-section v-html="activity.plagiarism_issues">
          
          </q-card-section>
        </q-card>
      </q-expansion-item>

       
    </q-list>
  </div>
</template>

<script>

export default {
    props: ['activities'],
    setup() {
        
    },
}
</script>
